/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
import Vue from 'vue'
import Vuex from 'vuex'
import { addDay, addSecond, formatTime, isDateEqual } from '../utils/date'
import { isServerAssetPath, makeUrl } from '../utils/lang'

Vue.use(Vuex)

export const ACTION_TYPES = {
  LOG_FIRST_BOOT: 'LOG_FIRST_BOOT',
  LOG_UPDATED: 'LOG_UPDATED',
  SET_NEXT_UPDATE_POINT: 'SET_NEXT_UPDATE_POINT',
  SET_POPUP: 'SET_POPUP',
  SET_LOADING: 'SET_LOADING',
  SET_SLIDE_SETTING: 'SET_SLIDE_SETTING',
  SET_ZODIAC_PEOPLE: 'SET_ZODIAC_PEOPLE',
  SET_SECONDARY_PAGE: 'SET_SECONDARY_PAGE',
  SET_ZODIAC_RANKING: 'SET_ZODIAC_RANKING',
  SET_BIRTHDAY_THIS_MONTH: 'SET_BIRTHDAY_THIS_MONTH',
  PUSH_POPUP: 'PUSH_POPUP',
}

export const RANKING_STATUS = {
  TOP: 'top', // vừa tăng thứ hạng và giành vị trí đầu bảng
  NEW: 'new', // có thay đổi nhưng không tăng thứ hạng
  UP: 'up',   // thứ hạng tăng
  DOWN: 'down', // thứ hạng giảm
  INTACT: 'intact', // mọi thứ giữ nguyên
}

export const SECONDARY_PAGE_TYPES = {
  NEWS: 'NEWS',
  VIDEO: 'VIDEO',
  YOUTUBE: 'YOUTUBE',
  PHOTO: 'PHOTO',
}

export const store = new Vuex.Store({
  state: {
    loading: true,
    appMeta: {
      firstBootAt: null,
      lastUpdatedAt: null,
      nextUpdatePoint: null
    },
    slideSetting: {},
    zodiacPeople: {},
    secondaryPage: [],
    zodiacRanking: {},
    birthdayThisMonth: {},
    popupQueue: []
  },
  getters: {
    appMeta: state => state.appMeta,
    firstBootAt: state => state.appMeta.firstBootAt,
    lastUpdatedAt: state => state.appMeta.lastUpdatedAt,
    nextUpdatePoint: state => state.appMeta.nextUpdatePoint,
    resetDailyAt: state => state.slideSetting.daily_reset_front_at,
    popupQueue: state => state.popupQueue,
    loading: state => state.loading,
    secondaryPage: state => state.secondaryPage,
    zodiacPeopleList: state => state.zodiacPeople.posts || [],
    zodiacPeopleConfig: state => state.zodiacPeople.config,
    slideSetting: state => state.slideSetting,
    popupSound: state => state.slideSetting && state.slideSetting.popup_sound,
    birthdayThisMonthConfig: state => state.birthdayThisMonth.config,
    birthdayThisMonthList: state => state.birthdayThisMonth.people || [],
    lateWork: state => state.birthdayThisMonth.lateWork,
    rankingChart: state => state.zodiacRanking.chart,
    salesFigures: state => ({
      sumProject: state.zodiacRanking.sum_project,
      sumContract: state.zodiacRanking.sum_contract,
      sumProductProjector: state.zodiacRanking.sum_product_projector,
    }),
  },
  mutations: {
    LOG_UPDATED(state, timestamp) {
      const { daily_reset_front_at } = state.slideSetting
      const { nextUpdatePoint, lastUpdatedAt } = state.appMeta
      const nowDate = timestamp || new Date()
      state.appMeta.lastUpdatedAt = nowDate

      if(!nextUpdatePoint || !isDateEqual(addDay(lastUpdatedAt, 1), nextUpdatePoint)) {
        // calc the next update
        // at 7:00AM daily
        // const nextPoint = addSecond(nowDate, 10)
        const nextPoint = addDay(nowDate, 1)
        if(daily_reset_front_at) {
          nextPoint.setHours(daily_reset_front_at.substr(0, 2))
          nextPoint.setMinutes(daily_reset_front_at.substr(3, 2))
          nextPoint.setSeconds(0)
        } else {
          nextPoint.setHours(7)
          nextPoint.setMinutes(0)
          nextPoint.setSeconds(0)
        }
        state.appMeta.nextUpdatePoint = nextPoint
      }
    },
    SET_NEXT_UPDATE_POINT(state, timestamp) {
      state.appMeta.nextUpdatePoint = timestamp
    },
    LOG_FIRST_BOOT(state, timestamp) {
      const nowDate = timestamp || new Date()

      if(state.appMeta.firstBootAt == null) {
        state.appMeta.firstBootAt = nowDate
      }
    },
    SET_POPUP(state, bool) {
      state.loading = !!bool
    },
    PUSH_POPUP(state, payload) {
      if(payload) {
        const { inText, department } = payload
        inText.forEach(item => {
          const _key = Math.floor(Math.random() * 1000000)
          const obj = {
            department,
            inText: item,
            _key
          }
          state.popupQueue.unshift(obj)
        })
      }
    },
    SET_LOADING(state, bool) {
      state.loading = !!bool
    },
    SET_SLIDE_SETTING(state, payload) {
      state.slideSetting = payload
    },
    SET_ZODIAC_PEOPLE(state, payload) {
      state.zodiacPeople = {
        config: payload.config,
        posts: payload.posts
      }
    },
    SET_SECONDARY_PAGE(state, payload) {
      const { pages } = payload
      const RX_HTML_URL = /((src|href)\=)(\")([^\<\>\\\s]+)(\")/g

      pages.forEach(page => {
        if(page.content) {
          page.slideType = SECONDARY_PAGE_TYPES.NEWS
          const iter = page.content.matchAll(RX_HTML_URL)
          for (const mch of iter) {
            const url = mch[4]
            if(isServerAssetPath(url)) {
              page.content = page.content.replace(url, makeUrl(url))
            }
          }
        } else if(page.__component.endsWith('photo-slide')) {
          page.slideType = SECONDARY_PAGE_TYPES.PHOTO
          if(page.photo && page.photo.url) {
            page.photo.url = makeUrl(page.photo.url)
          }
        } else if(page.__component.endsWith('video-slide')) {
          if(page.video_url) {
            page.slideType = SECONDARY_PAGE_TYPES.YOUTUBE
          } else if(page.video_media && page.video_media.url) {
            page.slideType = SECONDARY_PAGE_TYPES.VIDEO
            page.video_media.url = makeUrl(page.video_media.url)
          }
        }
      })

      state.secondaryPage = pages
    },
    SET_ZODIAC_RANKING(state, payload) {
      state.zodiacRanking = payload
    },
    SET_BIRTHDAY_THIS_MONTH(state, payload) {
      const { config, people, lateWork: { list, slide_interval } } = payload

      const employeeList = (list && list.employees) ? list.employees.map(emp => emp) : []

      state.birthdayThisMonth = {
        config: {
          ...config.config,
          order_by: config.order_by,
          order_strategy: config.order_strategy,
          allow_late_emp_list: config.allow_late_emp_list,
          no_data_message: config.no_data_message,
        },
        people,
        lateWork: {
          employeeList,
          slide_interval
        },
      }
    },
  },
  actions: {
    boostrapApp ({ commit, dispatch }, obj) {
      const {
        birthdayThisMonth,
        secondaryPage,
        slideSetting,
        zodiacPeople,
        zodiacRanking,
      } = obj

      commit(ACTION_TYPES.SET_ZODIAC_PEOPLE, zodiacPeople)
      commit(ACTION_TYPES.SET_SECONDARY_PAGE, secondaryPage)
      commit(ACTION_TYPES.SET_BIRTHDAY_THIS_MONTH, birthdayThisMonth)

      dispatch('setSlideSetting', slideSetting)
      dispatch('setZodiacRanking', zodiacRanking)
      dispatch('logEvent')
    },
    logUpdates({ commit }) {
      const timestamp = new Date()
      commit(ACTION_TYPES.LOG_UPDATED, timestamp)
    },
    logEvent({ commit }) {
      const timestamp = new Date()
      commit(ACTION_TYPES.LOG_FIRST_BOOT, timestamp)
      commit(ACTION_TYPES.LOG_UPDATED, timestamp)
    },
    setLoading ({ commit }, bool) {
      commit(ACTION_TYPES.SET_LOADING, bool)
    },
    setPopup ({ commit }, bool) {
      commit(ACTION_TYPES.SET_POPUP, bool)
    },
    setSlideSetting ({ commit, state }, obj) {
      const { daily_reset_front_at } = obj
      const { nextUpdatePoint } = state.appMeta
      if(daily_reset_front_at && nextUpdatePoint && !daily_reset_front_at.startsWith(formatTime(nextUpdatePoint))) {
        nextUpdatePoint.setHours(daily_reset_front_at.substr(0, 2))
        nextUpdatePoint.setMinutes(daily_reset_front_at.substr(3, 2))
        commit(ACTION_TYPES.SET_NEXT_UPDATE_POINT, new Date(nextUpdatePoint))
      }

      if(obj.popup_sound && obj.popup_sound.url) {
        obj.popup_sound = new Audio(makeUrl(obj.popup_sound.url))
      }

      commit(ACTION_TYPES.SET_SLIDE_SETTING, obj)
    },
    setZodiacPeople({ commit }, obj) {
      commit(ACTION_TYPES.SET_ZODIAC_PEOPLE, obj)
    },
    setSecondaryPage({ commit }, obj) {
      commit(ACTION_TYPES.SET_SECONDARY_PAGE, obj)
    },
    setZodiacRanking({ commit, state }, obj) {
      const oldChart = state.zodiacRanking.chart
      if(obj && obj.chart && oldChart) {
        const newChart = obj.chart
        newChart.forEach((kpi, newRank) => {
          const id = kpi.department.id
          const newPerf = kpi.perf
          const oldRank = oldChart.findIndex(kp => kp.department.id === id)
          if(oldRank > -1) {
            const oldPerf = oldChart[oldRank].perf
            if(newRank > oldRank) {
              kpi.status = RANKING_STATUS.DOWN
            } else if(newRank < oldRank) {
              kpi.status = newRank === 0 ? RANKING_STATUS.TOP : RANKING_STATUS.UP
            } else if(newPerf !== oldPerf) {
              kpi.status = RANKING_STATUS.NEW
            } else {
              kpi.status = RANKING_STATUS.INTACT
            }
          } else {
            kpi.status = RANKING_STATUS.NEW
          }
        })
      }
      commit(ACTION_TYPES.SET_ZODIAC_RANKING, obj)
    },
    setBirthdayThisMonth({ commit, state }, obj) {
      commit(ACTION_TYPES.SET_BIRTHDAY_THIS_MONTH, obj)
    },
    pushPopup({ commit }, obj) {
      commit(ACTION_TYPES.PUSH_POPUP, obj)
    },
  }
})
